module.exports = __webpack_public_path__ + "static/media/techCoastSales.e20ff152.jpg";